import React from "react";
import { CircularProgress } from "@material-ui/core";
import { notification } from "antd";
import { downloadDocument } from "../../../../../utils/common";
import { Strings } from "../../../../../dataProvider/localize";
import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";
import PreviewStyle from "../JobSwmsPreview/v3/PreviewV3.module.css";
import PreviewHeader from "../JobSwmsPreview/v3/PreviewHeader";
import PreviewSections from "../JobSwmsPreview/v3/PreviewSections";
import useJobShiftSwmsViewModel from "./useJobShiftSwmsViewModel";

const getPdfLink = (response = {}) => response && response.pdfLink;

const getSwmsDocument = (response = {}) => response && response.document;

export default function JobShiftSwmsOverlay({ open, context, onClose }) {
  const { loading, loaded, swms } = useJobShiftSwmsViewModel({ open, context });
  const pdfLink = getPdfLink(swms);
  const swmsDocument = getSwmsDocument(swms);
  const headerSwms = swms
    ? { ...swms, approval_status: swms.status ? swms.status : null }
    : swms;

  const handleDownload = () => {
    if (!pdfLink) return;
    downloadDocument(pdfLink, true).catch((error) => {
      notification.error({
        message: Strings.error_title,
        description: typeof error === "string" ? error : Strings.file_download_error,
        className: "ant-error"
      });
    });
  };

  if (!open) return null;

  return (
    <div className={styles.PreviewOverlay}>
      <div className={styles.PreviewModal}>
        <div className={styles.viewPreview}>
          <div className={styles.PreviewPlatformBar}>
            <button className={styles.PreviewPlatformButton} onClick={onClose} type="button">
              <svg height="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true">
                <path fill="currentColor" d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z" />
              </svg>
              <span>Back</span>
            </button>
            {!loading && loaded ? (
              <div className={styles.PreviewPlatformBarRight}>
                <button
                  className={styles.PreviewPlatformButton}
                  style={{ background: "#6366F1", color: "#fff", borderColor: "#6366F1" }}
                  disabled={!pdfLink}
                  onClick={handleDownload}
                  type="button"
                >
                  <svg height="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true">
                    <path fill="currentColor" d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 70.7 374.8 82.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM303 505C312.4 514.4 327.6 505 336.9 505L400.9 441C410.3 431.6 410.3 416.4 400.9 407.1C391.5 397.8 376.3 397.7 367 407.1L344 430.1L344 344C344 330.7 333.3 320 320 320C306.7 320 296 330.7 296 344L296 430.1L273 407.1C263.6 397.7 248.4 397.7 239.1 407.1C229.8 416.5 229.7 431.7 239.1 441L303.1 505z" />
                  </svg>
                  <span>Download</span>
                </button>
              </div>
            ) : null}
          </div>
          {loading || !loaded ? (
            <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100% - 54px)" }}>
              <CircularProgress size={30} />
            </div>
          ) : (
            <div className={`${styles.PreviewWrap} ${PreviewStyle.SwmsPreviewDocument}`}>
              <div className={styles.PreviewDoc}>
                <PreviewHeader
                  swmsData={swmsDocument}
                  swms={headerSwms}
                />
                <PreviewSections
                  swmsData={swmsDocument}
                  approvalStatus={swms && swms.approval_status}
                  jobId={context && context.jobId}
                  swmsId={context && context.swmsId}
                  onJsaActivitiesChange={() => {}}
                  showSignOff
                  staffSignOff={swms && swms.staff_sign_off}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
